export const state = {
    context: null,
    appConfig: null,
    requiresAuthentication: false,
    messagingActive: true,
    statusMessages: [],
    featureToggles: [],
    alertMessage: {
        title: null,
        message: null,
        alertClass: null,
        variant: null,
        optional: null,
        hasSearch: false
    },
    insights: null,
    loading: false,
    sharedUserMapGuid: null,
    userMapMessage: null
};

export default state;
